"use client";

import { usePathname } from "next/navigation";

import Header from "./Header";
import { Footer } from "./index";

type Props = {
  children: React.ReactNode;
  headerData: any;
  footerData: any;
};

export default function GlobalHeaderFooter({
  children,
  headerData,
  footerData,
}: Props) {
  const pathname = usePathname();

  // Toutes les pages agences
  const isAgencyPage =
    pathname.startsWith("/portage-de-repas");

  return (
    <>
      {!isAgencyPage && headerData && (
        <Header
          menuSuperieur={headerData.menuSuperieur}
          logo={headerData.menuPrincipal?.logo}
          menu={headerData.menuPrincipal?.menu}
        />
      )}

      <main>{children}</main>

      {!isAgencyPage && footerData && (
        <Footer
          menuFooter={footerData.menuFooter}
          logoFooter={footerData.LogoFooter}
        />
      )}
    </>
  );
}